import { withInstall } from '@lit-element/utils'
import Avatar from './src/avatar.vue'
import type { SFCWithInstall } from '@lit-element/utils'

export const LtAvatar: SFCWithInstall<typeof Avatar> = withInstall(Avatar)
export default LtAvatar

export * from './src/avatar'
export type { AvatarInstance } from './src/instance'
